import React from 'react';
import {useState} from 'react'
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
//import { useNavigate } from 'react-router-dom';
import { userLoginGoogle } from '../redux/user/actionCreator';
import googleImg from '../public/assets/google.png'
import BasicModal from '../utils/modal';
import AgeVarify from '../utils/AgeVarify';
import Image from 'next/image';
const LoginWithGoogle = ({ method = ''}) => {
  const dispatch = useDispatch();
  const navigate = useRouter();
  // const googleLogin = useGoogleLogin({
  //   onSuccess: async (tokenResponse) => {
  //     console.log(tokenResponse);
  //     dispatch(userLoginGoogle(tokenResponse, navigate));
  //   },
  //   onError: (errorResponse) => console.log(errorResponse),
  // });

  const googleSignIn = () => {
    dispatch(userLoginGoogle(navigate));
  }
  const [open, setOpen] = useState(false)
  const handleOpen = () => { 
    setOpen(true)
  };
  const handleClose = () =>{  
    setOpen(false)
    };

  return (
<> <BasicModal body={<AgeVarify/>} open={open} handleClose={handleClose} onRegistrationHandler={googleSignIn}></BasicModal>

    <div className=' px-8 py-4 cursor-pointer flex gap-2 dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 dark:hover:bg-accent hover:bg-accent font-semibold mb-4 flex w-full items-center justify-center rounded-full border-2 bg-white  text-center transition-all hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent uppercase'
      onClick={handleOpen}
    >
      <Image src={googleImg} width={20} height={20} alt='' />
      <button >{method}  with Google</button>
    </div>
    </>
  );
};

export default LoginWithGoogle;
